module.exports = __webpack_public_path__ + "static/media/quote-ekman-microexpressions.8c94c375.png";